(function () {
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.kc-swatch');
    if (!swatch) return;

    const card = swatch.closest('product-item.kc-card');
    if (!card) return;

    e.preventDefault();

    // Önceki seçiliyi bul (querySelectorAll yerine tek querySelector — daha hızlı INP)
    const prev = card.querySelector('.kc-swatch--selected');
    if (prev) {
      prev.classList.remove('kc-swatch--selected');
      prev.removeAttribute('aria-pressed');
    }
    swatch.classList.add('kc-swatch--selected');
    swatch.setAttribute('aria-pressed', 'true');

    // Image swap — srcset'i koru, responsive kalitesini düşürme
    const imgUrl = swatch.dataset.image;
    if (imgUrl) {
      const primary = card.querySelector('.kc-card__primary-img');
      if (primary) {
        // Shopify CDN URL'den otomatik srcset üret
        const base = imgUrl.replace(/[?&].*$/, '');
        primary.src = imgUrl;
        primary.srcset = [
          base.replace(/(_\d+x[\d]*)?\.(jpg|jpeg|png|webp)$/i, '_400x.$2') + ' 400w',
          base.replace(/(_\d+x[\d]*)?\.(jpg|jpeg|png|webp)$/i, '_600x.$2') + ' 600w',
          base.replace(/(_\d+x[\d]*)?\.(jpg|jpeg|png|webp)$/i, '_800x.$2') + ' 800w'
        ].join(', ');
        primary.sizes = primary.getAttribute('sizes') || '(max-width:740px) 50vw, 25vw';
      }
    }

    // Renk adı güncelle (aria-live="polite" ile ekran okuyucuya iletilir)
    const colorName = swatch.dataset.color;
    if (colorName) {
      const nameEl = card.querySelector('.kc-card__color-name');
      if (nameEl) nameEl.textContent = colorName;
    }

    // VW: kart linklerini kardeş ürüne güncelle
    if (swatch.classList.contains('kc-swatch--vw')) {
      const href = swatch.dataset.href;
      if (href) {
        const imgLink = card.querySelector('.kc-card__img-link');
        const titleLink = card.querySelector('.kc-card__title');
        if (imgLink) imgLink.href = href;
        if (titleLink) titleLink.href = href;
      }
    }
  });
})();
